import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location, onResolve, onReject) {
//     if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//     return originalPush.call(this, location).catch(err => err)
// }

export default new Router({
    mode: 'hash',
    routes: [{
            path: '/index',
            name: 'index',
            component: () =>
                import ('@/views/index/index'),
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/search',
            name: 'search',
            component: () =>
                import ('@/views/search/search'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/article',
            name: 'article',
            component: () =>
                import ('@/views/article/list'),
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/article/detail',
            name: 'articleDetail',
            component: () =>
                import ('@/views/article/detail'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/college',
            name: 'college',
            component: () =>
                import ('@/views/college/list'),
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/college/detail',
            name: 'collegeDetail',
            component: () =>
                import ('@/views/college/detail'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/vip',
            name: 'vip',
            component: () =>
                import ('@/views/vip/vip'),
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/my',
            name: 'my',
            component: () =>
                import ('@/views/my/my'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/app',
            name: 'app',
            component: () =>
                import ('@/views/my/app'),
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/',
            redirect: '/index',
        },
        {
            path: '*',
            redirect: '/index',
        },


    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js